import moment from "moment";
import {FlightReport, IFlightReport} from "../model/IFlightReport";
import {IFilter} from "../model/search/IFilter";
import {IPagination} from "../model/search/IPagination";
import {ISearch} from "../model/search/ISearch";
import {FlightReportService} from "../services/flightReport/FlightReportService";
import {HiringContractService} from "../services/HiringContractService";
import {notesService} from "../services/notes/NotesService";
import {IValidationResult} from "../model/errors/IValidationResult";

const getFlightReportById = async (
    flightReportId: number,
    strToken: string,
) => {
    await FlightReportService.getById(flightReportId);
};

const createAndUpdate = async (
    flightReport: FlightReport,
    auth: any,
    strToken: string,
    ignoreWarning: boolean,
): Promise<IValidationResult<IFlightReport>> => {
    if (flightReport?.flightReportId) {
        //update last updated by & last updated on timestamp
        flightReport.updateTimestamp = moment(new Date()).format("yyyy-MM-DD");
        flightReport.updateUserId = auth?.user?.profile?.name ?? "wildfire";

        return await FlightReportService.update(
            flightReport,
            strToken,
            ignoreWarning,
        );
    } else {
        //update created by & created on timestamp
        flightReport.createTimestamp = moment(new Date()).format("yyyy-MM-DD");
        flightReport.createUserId = auth?.user?.profile?.name ?? "wildfire";

        return await FlightReportService.create(
            flightReport,
            strToken,
            ignoreWarning,
        );
    }
};

const deleteFlightReportById = async (
    flightReport: FlightReport,
    auth: any,
    strToken: string,
) => {
    if (flightReport?.flightReportId) {
        //update last updated by and set deleted to true
        flightReport.updateUserId = auth?.user?.profile?.name ?? "wildfire";
        flightReport.deleted = true;

        return await FlightReportService.deleteById(flightReport, strToken);
    }
};

const updateFlagged = async (flightReport: IFlightReport, strToken: string) => {
    if (flightReport?.flightReportId) {
        return await FlightReportService.updateFlagged(flightReport, strToken);
    }
};

async function getHiringContract(reportDate: string, strToken: string) {
    let objIPagination: IPagination = {
        perPage: 1500,
        page: 1,
    };

    let objIFilter: IFilter = {
        columnName: "reportDate",
        columnValue: moment(reportDate).format("yyyy-MM-DD"),
    };

    let objISearch: ISearch = {
        search: "",
        filterBy: objIFilter,
        pagination: objIPagination,
    };

    var response = await HiringContractService.getSearch(objISearch, strToken);
    return response.data.data;
}

async function getCharterNotes(charterid: number, strToken: string) {
    var response = await notesService.getCharterNotes(charterid, strToken);
    return response.data;
}

async function getActiveContract(
    reportDate: string,
    search: string,
    strToken: string,
) {
    let objIPagination: IPagination = {
        perPage: 10,
        page: 1,
    };

    let objISearch: ISearch = {
        flightReportDate: moment(reportDate).format("yyyy-MM-DD"),
        search: search,
        pagination: objIPagination,
    };

    var response = await HiringContractService.getByDate(objISearch, strToken);
    return response.data.data;
}

export const FlightReportCRUD = {
    getFlightReportById,
    createAndUpdate,
    updateFlagged,
    getHiringContract,
    getActiveContract,
    deleteFlightReportById,
    getCharterNotes,
};
